import { Button, Form, Input } from "antd";

import styles from "./index.module.less";
import { useRequestPasswordReset } from "./index.hook";
import { General } from "../../../util/General";
import FormInputRules from "../../../util/FormInputRules";
import CircularProgressBar from "../../common/CircularProgressBar";
import { CustomerSideNextScreenConstants } from "../../../constants/generalConstants";

import type { AuthUserAPIResponse } from "../../../shared/interface/auth/User.interface";

type RequestPasswordResetProps = {
  nextScreenHelper: (response: AuthUserAPIResponse) => void;
  handleNextScreen: (value: CustomerSideNextScreenConstants | null) => void;
};

const RequestPasswordReset = (props: RequestPasswordResetProps) => {
  const config = useRequestPasswordReset(props);

  return (
    <>
      <Form onFinish={config?.handleOk} layout="vertical" autoComplete="off" validateTrigger="onBlur" name="basic" className={`gx-signin-form gx-form-row0 gx-mb-4`}>
        <h3 className="gx-mt-2 gx-mb-4 ">Request to Reset Password.</h3>
        <Form.Item name="username" label="Username" normalize={General.inputWhiteSpaceRemove} rules={[FormInputRules.requiredFieldInputRule("username")]}>
          <Input name="username" />
        </Form.Item>

        <div className={`${styles["password-btn-container"]} gx-mt-4`}>
          <Button className={`${styles["password-form-button"]} button-gradiant gx-mb-0`} onClick={config.handleBack}>
            Back
          </Button>

          <Button className={`${styles["password-form-button"]} button-gradiant gx-mb-0`} htmlType="submit" disabled={config?.saving}>
            {config?.saving ? <CircularProgressBar /> : "Submit"}
          </Button>
        </div>
      </Form>
    </>
  );
};

export default RequestPasswordReset;
